export const BSC_RPC_NODE_URLS = [
  // "https://binance.ankr.com/", - fast but has issues with contracts
  "https://bsc-dataseed1.binance.org/",
  "https://bsc-dataseed2.binance.org/",
  "https://bsc-dataseed3.binance.org/",
  "https://bsc-dataseed4.binance.org/",
]
